import gql from "graphql-tag";

export const GET_CURRENT_PHOTO = gql`
    query photoDetail($photoId: ID!) {
        photoDetail(photoId: $photoId) {
            id
            slugWithId
            title
            description
            license
            isPremium
            creator {
                id
                name
                username
                avatarUrl
            }
            assets {
                thumbnailMedium
                thumbnailLarge
            }
            ratio
            createdAt
            freeDimensions {
                pixelWidth
                pixelHeight
                printDpi
                printWidth
                printHeight
            }
            largeDimensions {
                pixelWidth
                pixelHeight
                printDpi
                printWidth
                printHeight
            }
            fullDimensions {
                pixelWidth
                pixelHeight
                printDpi
                printWidth
                printHeight
            }
        }
    }
`;
